var lib_core      = require("lib-core");
var lib_geometry      = require("lib-geometry");
var THREE         = require("three");
var Handle3dModel  = require("./../../../abstract/handle3dModel.js");

var RadialHandleModel = function (editorModel, handleId) {
    Handle3dModel.call(this, editorModel, handleId);
};

lib_core.inherit(RadialHandleModel, Handle3dModel);
RadialHandleModel.$class = "RadialHandleModel";
module.exports = RadialHandleModel;


RadialHandleModel.prototype.getSubjectsCenter = function(){
    console.error("not implimented");
} 

RadialHandleModel.prototype.getSubjectsRadius = function(){
    console.error("not implimented");
} 

RadialHandleModel.prototype.getSubjectsRotation = function(){
    return 0;
} 

RadialHandleModel.prototype.createMovementPlane = function(ray, point){}

RadialHandleModel.prototype.setContactPosition = function(position){}

RadialHandleModel.prototype.setMousePosition = function(position){}

RadialHandleModel.prototype.released = function(){}